"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setDelayState;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function setDelayState() {
  var durationSeconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _this = this;

  var stateName = arguments[1];
  var callback = arguments[2];

  return setTimeout(function () {
    _this.setState(_defineProperty({}, stateName, true));

    if (callback) callback();
  }, parseFloat(durationSeconds) * 1000);
}